import {
    HISTORICAL_DOCUMENTS_SORT_FIELDS,
    type HistoricalDocumentsSortField,
} from '../constants';

const SORT_FIELD_TO_COLUMN_ID: Record<HistoricalDocumentsSortField, string> = {
    [HISTORICAL_DOCUMENTS_SORT_FIELDS.DOCUMENT_DESCRIPTION]: 'documentDescription',
    [HISTORICAL_DOCUMENTS_SORT_FIELDS.UPLOADED_DATE]: 'uploadedDate',
};

const COLUMN_ID_TO_SORT_FIELD = Object.fromEntries(
    Object.entries(SORT_FIELD_TO_COLUMN_ID).map(([sortField, columnId]) => [columnId, sortField]),
) as Record<string, HistoricalDocumentsSortField>;

export function sortFieldToColumnId(sortColumn: HistoricalDocumentsSortField): string {
    return SORT_FIELD_TO_COLUMN_ID[sortColumn];
}

export function columnIdToSortField(columnId: string): HistoricalDocumentsSortField | undefined {
    return COLUMN_ID_TO_SORT_FIELD[columnId];
}
